import {
  Card,
  CardBody,
  Divider,
  Flex,
  IconButton,
  SimpleGrid,
  Text,
} from '@chakra-ui/react';
import { GrEdit } from 'react-icons/gr';
import { R$ } from 'shared/helpers/currency';
import { KeyValue } from '../atoms/KeyValue';

interface PlanDetailsCardProps {
  periodicityLabel: string;
  planName: string;
  planPrice: number;
  onEdit?: () => void;
}

export const PlanDetailsCard: React.FC<PlanDetailsCardProps> = ({
  periodicityLabel,
  planName,
  planPrice,
  onEdit,
}) => (
  <Card
    backgroundColor="#F5F6F6"
    borderRadius="xl"
    border={'1px'}
    borderColor={'#E5E7E8'}
  >
    <CardBody>
      <Flex align="center" justify="space-between" mb="4">
        <Text fontWeight="semibold">Detalhes do Plano</Text>
        {onEdit && (
          <IconButton
            aria-label="Editar plano"
            variant="ghost"
            size="md"
            icon={<GrEdit />}
            onClick={onEdit}
          />
        )}
      </Flex>

      <Divider />

      <SimpleGrid columns={[1, 3]} spacing="6" pt="6">
        <KeyValue label="Tipo" value={periodicityLabel} />
        <KeyValue label="Plano" value={planName} />
        <KeyValue label="Valor" value={R$(planPrice)} />
      </SimpleGrid>
    </CardBody>
  </Card>
);
